import { styled } from '../../../../stitches.config';
import { Button as CoreButton } from '../../../controls/Button/Button';
import { SimplifiedTooltip } from '../../../containers/Tooltip';

const Container = styled('div', {
  position: 'absolute',
  right: 0,
  top: '50%',
  transform: 'translateY(-50%)',
});

const Button = styled(CoreButton, {
  'padding': '$2 !important',
  '& > span': {
    fontSize: '$3 !important',
  },
});

interface StartSearchFromLeafProps {
  onClick: () => void;
}

export function StartSearchFromLeaf(props: StartSearchFromLeafProps) {
  const { onClick } = props;

  return (
    <Container>
      <SimplifiedTooltip
        content="Start new search from here"
        contentProps={{
          css: {
            fontSize: '12px',
          },
        }}
      >
        <Button size="small" theme="orange" icon="search" onClick={onClick} />
      </SimplifiedTooltip>
    </Container>
  );
}
